import React, { useState } from 'react';
import { ROOMS, RESERVATION_STATUS } from '../../Constants/rooms';
import { addDays, fromYmd, toYmd, todayYmd } from '../../Util/dateUtil';

const emptyForm = {
    room: ROOMS[0].key,
    guestName: '',
    phone: '',
    checkIn: todayYmd(),
    checkOut: toYmd(addDays(new Date(), 1)),
    headcount: '',
    status: 'CONFIRMED',
    memo: '',
};

/** 예약 등록·수정 모달 */
const ReservationForm = ({ mode, initial = {}, onSubmit, onClose }) => {
    const [form, setForm] = useState(() => {
        const merged = { ...emptyForm, ...initial };
        // '이 날짜로 등록'처럼 입실일만 넘어온 경우 퇴실일을 하루 뒤로 맞춰줍니다.
        if (initial.checkIn && !initial.checkOut) {
            merged.checkOut = toYmd(addDays(fromYmd(initial.checkIn), 1));
        }
        return merged;
    });
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const set = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));

    const onCheckInChange = (e) => {
        const checkIn = e.target.value;
        setForm(prev => ({
            ...prev,
            checkIn,
            // 입실일이 퇴실일 이후로 밀리면 퇴실일을 자동으로 당겨줍니다.
            checkOut: checkIn && prev.checkOut <= checkIn ? toYmd(addDays(fromYmd(checkIn), 1)) : prev.checkOut,
        }));
    };

    const submit = async (e) => {
        e.preventDefault();
        if (busy) return;

        if (!form.checkIn || !form.checkOut) return setError('입실일과 퇴실일을 입력해 주세요.');
        if (form.checkOut <= form.checkIn) return setError('퇴실일은 입실일보다 뒤여야 합니다.');

        setBusy(true);
        setError(null);
        try {
            await onSubmit({
                room: form.room,
                guestName: form.guestName.trim(),
                phone: form.phone.trim(),
                checkIn: form.checkIn,
                checkOut: form.checkOut,
                headcount: form.headcount === '' ? null : Number(form.headcount),
                status: form.status,
                memo: form.memo.trim(),
            });
        } catch (err) {
            setError(err.message || '저장에 실패했습니다.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="admin-modal-backdrop" onClick={onClose}>
            <form className="admin-modal" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
                <div className="admin-modal-head">
                    <h2>{mode === 'edit' ? '예약 수정' : '예약 등록'}</h2>
                    <button type="button" className="admin-modal-close" onClick={onClose} aria-label="닫기">✕</button>
                </div>

                <div className="admin-form-grid">
                    <label>
                        <span>객실 *</span>
                        <select value={form.room} onChange={set('room')}>
                            {ROOMS.map(({ key, standard }) => (
                                <option key={key} value={key}>{key} ({standard})</option>
                            ))}
                        </select>
                    </label>

                    <label>
                        <span>상태 *</span>
                        <select value={form.status} onChange={set('status')}>
                            {RESERVATION_STATUS.map(({ key, label }) => (
                                <option key={key} value={key}>{label}</option>
                            ))}
                        </select>
                    </label>

                    <label>
                        <span>입실일 *</span>
                        <input type="date" value={form.checkIn} onChange={onCheckInChange} required />
                    </label>

                    <label>
                        <span>퇴실일 *</span>
                        <input type="date" value={form.checkOut} onChange={set('checkOut')} min={form.checkIn} required />
                    </label>

                    <label>
                        <span>예약자명</span>
                        <input type="text" value={form.guestName} onChange={set('guestName')} placeholder="홍길동" maxLength={50} />
                    </label>

                    <label>
                        <span>연락처</span>
                        <input type="tel" value={form.phone} onChange={set('phone')} placeholder="010-0000-0000" maxLength={20} />
                    </label>

                    <label>
                        <span>인원</span>
                        <input type="number" value={form.headcount} onChange={set('headcount')} min={1} max={50} placeholder="4" />
                    </label>

                    <label className="admin-form-full">
                        <span>메모</span>
                        <textarea value={form.memo} onChange={set('memo')} rows={3} placeholder="숯불 예약, 평상 추가 등" />
                    </label>
                </div>

                <p className="admin-form-hint">※ 퇴실일 당일은 비어있는 것으로 계산됩니다. (8/2 입실 ~ 8/4 퇴실 = 8/2, 8/3 2박)</p>

                {error && <div className="admin-form-error">{error}</div>}

                <div className="admin-modal-foot">
                    <button type="button" className="admin-btn" onClick={onClose}>취소</button>
                    <button type="submit" className="admin-btn admin-btn--primary" disabled={busy}>
                        {busy ? '저장 중…' : '저장'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ReservationForm;